import { onReady } from "../../utils/events/onReady";
import { addEvent } from "../../utils/events/events";
import { onClickOutside } from "../../utils/events/onClickOutside";

export class Navigation {
    /**
     * Internal placeholder for DOM-objects
     *
     * @type {object}
     * @ignore
     */
    dom = {
        container: undefined
    };

    state = {
        open: false
    };

    /**
     *
     * @param {Element} domReference - The element to work from
     */
    constructor(domReference) {
        this.dom.container = domReference;
        onReady(() => this.init());
    }

    openMenu(e) {
        const searchDesktop = document.querySelector(".header__search");
        searchDesktop.style.display = "none";

        if (e.target.classList.contains("header__left--navigation-link")) {
            onClickOutside(this.dom.container, () => this.closeMenu());
            e.target.setAttribute(
                "aria-pressed",
                !JSON.parse(e.target.getAttribute("aria-pressed"))
            );
            const containerMenu = e.target.parentNode.children[1];
            const currentStatus = JSON.parse(
                containerMenu.getAttribute("aria-expanded")
            );
            document.querySelector("body").classList.add("no-scroll");
            containerMenu.setAttribute("aria-expanded", !currentStatus);
            const arrayNav = document.querySelectorAll(
                ".header__menu-container.grid"
            );
            arrayNav.forEach(item => {
                if (item !== containerMenu) {
                    item.setAttribute("aria-expanded", false);
                    item.parentNode.children[0].setAttribute(
                        "aria-pressed",
                        false
                    );
                }
            });
        }
    }

    checkNavigation() {
        const nodeList = document.querySelectorAll(
            ".header__menu-container.grid"
        );
        const arrayNav = Array.from(nodeList);
        const isExpanded = element =>
            element.getAttribute("aria-expanded") === "false";
        if (!arrayNav.every(isExpanded)) {
            document.querySelector("header").classList.add("menu-open");
        } else {
            document.querySelector("header").classList.remove("menu-open");
            const mobileMenu = document
                .querySelector(".button.button__header--mobile")
                .getAttribute("aria-expanded");
            if (!JSON.parse(mobileMenu)) {
                document.querySelector("body").classList.remove("no-scroll");
            }
        }
    }

    closeMenu() {
        const header = document.querySelector("header");
        header.classList.remove("menu-open");
        document.querySelector("body").classList.remove("no-scroll");
        this.dom.container
            .querySelectorAll(
                ".header__left--navigation .header__left--navigation-item"
            )
            .forEach(item => {
                if (item.children.length > 1) {
                    item.children[0].setAttribute("aria-pressed", false);
                    item.children[1].setAttribute("aria-expanded", false);
                }
            });
    }

    init() {
        this.dom.container
            .querySelectorAll("li.header__left--navigation-item")
            .forEach(item => {
                item.addEventListener("click", e => {
                    this.openMenu(e);
                    this.checkNavigation();
                });
            });
        this.dom.container
            .querySelectorAll("li.header__left--navigation-item")
            .forEach(item => {
                addEvent(item, "keyup", e => {
                    if (e.key === "Enter" || e.keyCode === 13) {
                        this.openMenu(e);
                        this.checkNavigation();
                    }
                });
            });

        addEvent(document, "keyup", e => {
            if (e.key === "Escape" || e.keyCode === 27) {
                this.closeMenu();
            }
        });
        this.dom.container
            .querySelectorAll(".header__menu-close-button")
            .forEach(item => {
                addEvent(item, "click", () => this.closeMenu());
            });
    }
}
